<template>
    <connect-network-failed-view @go-to-source="goToNetworks" />
</template>

<script>
    import ConnectNetworkFailedView from '../data-views/networks/ConnectNetworkFailedView';
    import useRouter from '../../../src/composables/use-router';
    export default {
        name: 'CampaignConnectNetworkFailedRouterView',
        components: {
            ConnectNetworkFailedView
        },
        setup() {
            const router = useRouter().get();
            const goToNetworks = () => {
                router.push({ name: 'manage.networks' });
            };

            return {
                goToNetworks
            };
        }
    };
</script>
